import { Navigate, Outlet } from 'react-router-dom';
import {get, post} from '../helpers/httpClient'
import { useState, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import './layout.css';
import { BiLogOut } from "react-icons/bi";

function App() {
  const [user, setUser] = useState({useranme: 'unknown'})
  const [isAdmin, setIsAdmin] = useState(false)
  const [burgerOpen, setBurgerOpen] = useState(false)
  const isAuthenticated = localStorage.getItem('token')

  const getCurrentUserInfo = () => {
    get(
      'whoami',
      function(response) {
         if (response === null) {
             return <Navigate to="/login" />;
         }
        setUser(response.user)
        if (response.user.roles.findIndex((val) => val === 'ROLE_ADMIN') !== -1) {
          setIsAdmin(true)
        } else {
          setIsAdmin(false)
        }
      }
    ).then(() => {
        if (isAuthenticated === null || isAuthenticated === 'null') {
            return <Navigate to="/login" />;
        }
    })
  }

    const logout = () => {
        post('logout', {token: localStorage.getItem('token')}, () => window.location.href = '/login')
    }

  useEffect(() => { getCurrentUserInfo(); }, [isAuthenticated]);

  return (
    <div className="app-shell">
      <ToastContainer />
      <header className="app-header">
        <div className="header-inner">
          <a className="brand" href="/">Website Builder</a>

          {/* Mobile burger menu */}
          <div className="header-burger">
            <button
              type="button"
              className="nav-button"
              aria-haspopup="listbox"
              aria-expanded={burgerOpen}
              id="header-burger-btn"
              onClick={() => setBurgerOpen(o => !o)}
            >
              Menu ▾
            </button>
            <ul className={`burger-menu ${burgerOpen ? 'open' : ''}`} role="listbox" aria-labelledby="header-burger-btn">
              {isAdmin && <li><a href="/clients">Clients</a></li>}
              <li><a href="/websites">Websites</a></li>
              <li><a href="/user-settings">{user.name}</a></li>
              <li>
                <button type="button" className="nav-button" onClick={logout} title="Logout" aria-label="Logout">
                  <BiLogOut size={'1.44rem'} /> Logout
                </button>
              </li>
            </ul>
          </div>

          {/* Desktop nav */}
          <nav className="nav">
            <ul>
              {isAdmin && <li><a href="/clients">Clients</a></li>}
              <li><a href="/websites">Websites</a></li>
              <li><a href="/user-settings">{user.name}</a></li>
              <li><button type="button" className="nav-button" onClick={logout} title="Logout" aria-label="Logout">
                <BiLogOut size={'1.7rem'} />
              </button></li>
            </ul>
          </nav>
        </div>
      </header>

      <main className="app-content">
        <Outlet context={[user, getCurrentUserInfo]} />
      </main>

      <footer className="app-footer">
        <div className="footer-inner">
          <p>© Website Builder. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default App;